// src/pages/projects/index.js
import React, { useState } from 'react'
import './style.css'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { Container, Row, Col, Card, Badge } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { meta } from '../../content_option'
import { projectsConfig, getFeaturedProjects } from '../../config/projects'

export const Projects = () => {
  const [selectedCategory, setSelectedCategory] = useState('all')

  const getFilteredProjects = () => {
    let filtered = projectsConfig.projects

    if (selectedCategory !== 'all') {
      filtered = filtered.filter(project => project.category === selectedCategory)
    }
    return filtered.filter(project => project.display.showInPortfolio)
  }

  const handleProjectLaunch = (project) => {
    switch (project.display.launchType) {
      case 'subdomain':
      case 'external':
        window.open(project.deployment.url, '_blank')
        break
      case 'embedded':
        window.location.href = `/projects/${project.id}`
        break
      default:
        window.open(project.deployment.url, '_blank')
    }
  }

  const getStatusBadgeVariant = (status) => {
    switch (status) {
      case 'live': return 'success'
      case 'development': return 'warning'
      case 'archived': return 'secondary'
      default: return 'primary'
    }
  }

  const filteredProjects = getFilteredProjects()
  const featuredProjects = getFeaturedProjects()

  return (
    <HelmetProvider>
      <section id='projects' className='projects'>
        <Helmet>
          <meta charSet='utf-8' />
          <title>Projects | {meta.title}</title>
          <meta
            name='description'
            content='Explore my collection of web applications, tools, and experiments'
          />
        </Helmet>

        <Container className='projects-container'>
          {/* Header */}
          <Row className='mb-5 mt-3 pt-md-3'>
            <Col lg='12' className='text-center'>
              <Link to='/' className='back-link'>
                ← Back to Home
              </Link>
              <h1 className='display-4 mb-2'>Projects</h1>
              <p className='lead'>A collection of things I've built</p>
              <hr
                className='t_border my-4 mx-auto'
                style={{ width: '100px' }}
              />
            </Col>
          </Row>

          {/* Featured Projects */}
          {featuredProjects.length > 0 && (
            <Row className='mb-5 featured-projects-grid'>
              <Col lg='12'>
                <h2 className='section-title mb-4'>Featured Work</h2>
                <Row>
                  {featuredProjects.map((project) => (
                    <Col
                      lg='6'
                      md='6'
                      sm='12'
                      key={project.id}
                      className='mb-4'
                    >
                      <Card
                        className='project-card featured-card h-100'
                        onClick={() => handleProjectLaunch(project)}
                      >
                        <div className='project-thumbnail'>
                          {project.display.thumbnail ? (
                            <Card.Img
                              variant='top'
                              src={project.display.thumbnail}
                              alt={project.title}
                              className='project-image'
                            />
                          ) : (
                            <div className='placeholder-image'>
                              <div className='placeholder-text'>📱</div>
                            </div>
                          )}
                          <div className='project-overlay'>
                            <button
                              className='launch-btn'
                              onClick={(e) => {
                                e.stopPropagation()
                                handleProjectLaunch(project)
                              }}
                            >
                              View Project
                            </button>
                          </div>
                        </div>
                        <Card.Body>
                          <Badge
                            bg={getStatusBadgeVariant(project.status)}
                            className='status-badge'
                          >
                            {project.status}
                          </Badge>
                          <Card.Title className='project-title'>
                            {project.title}
                          </Card.Title>
                          <Card.Text className='project-description'>
                            {project.description}
                          </Card.Text>
                          <div className='project-actions'>
                            <button
                              className='btn btn-primary btn-sm'
                              onClick={(e) => {
                                e.stopPropagation()
                                handleProjectLaunch(project)
                              }}
                            >
                              Launch
                            </button>
                            {/* <a 
                              href={project.deployment.repository}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-outline-secondary btn-sm"
                              onClick={(e) => e.stopPropagation()}
                            >
                              Code
                            </a> */}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          )}

          {/* Filters - Simplified */}
          <Row className='mb-4'>
            <Col lg='12'>
              <div className='filters-section'>
                <h3>Filter by Category</h3>
                <div className='filter-group'>
                  <label className='filter-label'>Show:</label>
                  <select
                    className='form-select filter-select'
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    <option value='all'>All Projects</option>
                    {Object.entries(projectsConfig.categories).map(
                      ([key, label]) => (
                        <option key={key} value={key}>
                          {label}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            </Col>
          </Row>

          {/* All Projects Grid */}
          <Row className='mb-5 all-projects-grid'>
            <Col lg='12'>
              <h2 className='section-title mb-4'>
                All Work ({filteredProjects.length})
              </h2>
              {filteredProjects.length === 0 ? (
                <div className='text-center py-5'>
                  <p className='text-muted'>
                    No projects match your current filter.
                  </p>
                </div>
              ) : (
                <Row>
                  {filteredProjects.map((project) => (
                    <Col
                      lg='4'
                      md='6'
                      sm='12'
                      key={project.id}
                      className='mb-4'
                    >
                      <Card
                        className='project-card h-100'
                        onClick={() => handleProjectLaunch(project)}
                      >
                        <div className='project-thumbnail'>
                          {project.display.thumbnail ? (
                            <Card.Img
                              variant='top'
                              src={project.display.thumbnail}
                              alt={project.title}
                              className='project-image'
                            />
                          ) : (
                            <div className='placeholder-image'>
                              <div className='placeholder-text'>🛠️</div>
                            </div>
                          )}
                          <div className='project-overlay'>
                            <button
                              className='launch-btn'
                              onClick={(e) => {
                                e.stopPropagation()
                                handleProjectLaunch(project)
                              }}
                            >
                              View
                            </button>
                          </div>
                        </div>
                        <Card.Body>
                          <Badge
                            bg={getStatusBadgeVariant(project.status)}
                            className='status-badge'
                          >
                            {project.status}
                          </Badge>
                          <Card.Title className='project-title'>
                            {project.title}
                          </Card.Title>
                          <Card.Text className='project-description'>
                            {project.description}
                          </Card.Text>
                          <div className='project-actions'>
                            <button
                              className='btn btn-primary btn-sm'
                              onClick={(e) => {
                                e.stopPropagation()
                                handleProjectLaunch(project)
                              }}
                            >
                              Launch
                            </button>
                            {/* <a
                              href={project.deployment.repository}
                              target='_blank'
                              rel='noopener noreferrer'
                              className='btn btn-outline-secondary btn-sm'
                              onClick={(e) => e.stopPropagation()}
                            >
                              Code
                            </a> */}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </HelmetProvider>
  )
}